module.exports = __webpack_public_path__ + "img/lb.e592141d.svg";